// extracted by mini-css-extract-plugin
export var standaloneTable = "_13-0";
export var standaloneTableWithBodyFill = "_13-1";
export var withExtraHeader = "_13-2";